<template>
  <div class="account-mapping-page-header__outer-container">
    <div>
      <span class="account-mapping-page-header__title">{{
        I18n.t('account_mapping_list.account_mapping')
      }}</span>
    </div>
    <AccountMappingActions v-bind="$props" />
  </div>
</template>

<script>
import AccountMappingActions from './account-mapping-actions.vue'

export default {
  components: {
    AccountMappingActions,
  },

  props: {
    authenticityToken: {
      type: String,
      required: true,
    },
    saveMethod: {
      type: String,
      required: true,
    },
    asyncSaveUrl: {
      type: String,
      required: true,
    },
    saveUrl: {
      type: String,
      required: true,
    },
    saveBatchSize: {
      type: Number,
      required: true,
    },
    aiMode: {
      type: Boolean,
    },
  },
}
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.account-mapping-page-header {
  &__outer-container {
    @include background-color('white');

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: space(3);
    border-bottom: 1px solid -color('snow', 'dark');
  }

  &__title {
    @include color('text');
    @include font-size('heading', 'm');
    @include font-weight('medium');

    line-height: 1.33;
  }
}
</style>
